module.exports = __webpack_public_path__ + "static/media/mannok.c8dcfde4.png";